import React from 'react';

function ContactTab({ contacts, handleContactChange, addContact, removeContact }) {
  return (
    <div>
      {contacts.map((c, i) => (
        <div key={i} className="border rounded p-3 mb-4 position-relative bg-light">
          <h6 className="mb-3">Contact {i + 1}</h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Contact Person <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={c.contact_person}
                onChange={(e) => handleContactChange(i, 'contact_person', e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Designation</label>
              <input
                type="text"
                className="form-control"
                value={c.department}
                onChange={(e) => handleContactChange(i, 'department', e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Phone 1 <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={c.phone1}
                onChange={(e) => handleContactChange(i, 'phone1', e.target.value)}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Phone 2</label>
              <input
                type="text"
                className="form-control"
                value={c.phone2}
                onChange={(e) => handleContactChange(i, 'phone2', e.target.value)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                value={c.email || ''}
                onChange={(e) => handleContactChange(i, 'email', e.target.value)}
              />
            </div>
          </div>

          {contacts.length > 1 && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm position-absolute"
              style={{ top: '10px', right: '10px' }}
              onClick={() => removeContact(i)}
            >
              🗑 Remove
            </button>
          )}
        </div>
      ))}

      <button type="button" className="btn btn-outline-primary" onClick={addContact}>
        ➕ Add Contact
      </button>
    </div>
  );
}

export default ContactTab;
